import script from "./RegistrationExemPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationExemPage.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationExemPage.vue?vue&type=style&index=0&id=564231a5&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564231a5"]])

export default __exports__